// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Hz-z","tooltipWrapper":"Iz-z","icon":"Jz-z","tooltip":"Kz-z","content":"Lz-z"};